module.exports = __webpack_public_path__ + "files/77adee15f25167b88746d567c853b336.png";